import { Injectable, Inject } from "@angular/core";
import { Router } from "@angular/router";
// import { environment } from "../../../environments/environment.prod";
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from "rxjs";
import { Messaging, getToken, onMessage, deleteToken } from '@angular/fire/messaging';
import { SweetAlert } from "../sweet-alert";

@Injectable({
  providedIn: "root"
})
export class MessagingServiceService {
    private localStorage: Storage = {
    getItem: () => "",
    setItem: () => null,
    removeItem: () => null,
    clear: () => null,
    length: 0,
    key: () => null,
  } satisfies Storage;
  currentMessage = new BehaviorSubject(null);
  webNotify = new BehaviorSubject(false);
  private hasRequestedPermission = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private messaging: Messaging // Injecting the Messaging service
  ) {
    this.localStorage = typeof window !== 'undefined' ?typeof window !== "undefined" && window.localStorage : null;
  }

  requestPermission() {
    // Only request permission if it hasn't been requested already and we're in browser
    if (this.hasRequestedPermission || typeof window === 'undefined') {
      return;
    }
    
    this.hasRequestedPermission = true;
    
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        // Get FCM token (use your actual VAPID key)
        getToken(this.messaging, {
          // TODO: add vapidKey
          // vapidKey: environment.firebaseConfig.vapidKey
        })
          .then((token) => {
            this.saveToken(token);
          })
          .catch((err) => {
            console.log('Unable to get permission to notify.', err);
          });
      }
    });
  }

  receiveMessage() {
    onMessage(this.messaging, (payload) => {
      this.showNotification(payload);
    });
  }

  getPermission() {
    this.requestPermission();
  }

  showNotification(payload) {
    let currentUrl = this.router.url;
    let isChat = parseInt(payload.data.is_chat);
    let notifyTitle = payload.notification.title;
    let notifyBody = payload.notification.body;

    if(currentUrl == '/dentist/messages' || currentUrl == '/patient/messages') {
      this.webNotify.next(true);
    }

    if(isChat == 1 && currentUrl != '/dentist/messages' && currentUrl != '/patient/messages') {
      SweetAlert.swal({ title: notifyTitle, text: notifyBody, type: "success", timer: 3000}, isConfirm => { if (isConfirm) {} });
    }

    if(isChat == 2) {
      notifyBody = 'You have a new message from the Dentist/Dental office.'
      SweetAlert.swal({ title: notifyTitle, text: notifyBody, type: "success", timer: 3000}, isConfirm => { if (isConfirm) {} });
    }

    if(isChat == 0) {
      SweetAlert.swal({ title: notifyTitle, text: notifyBody, type: "success", timer: 3000}, isConfirm => { if (isConfirm) {} });
    }
  }

  // Revised monitor refresh to avoid unnecessary token refreshing
  monitorRefresh() {
    // Only call if we have a saved token that might need refreshing
    if (this.localStorage && this.localStorage.getItem('web_token')) {
      getToken(this.messaging, {
        // TODO: add vapidKey
        // vapidKey: environment.firebaseConfig.vapidKey
      }).then(token => {
        if (token !== this.localStorage.getItem('web_token')) {
          this.saveToken(token);
        }
      }).catch(err => console.log(err, 'Unable to retrieve token'));
    }
  }

  saveToken(token) {
    if (this.localStorage) {
      this.localStorage.setItem("web_token", token);
    }
  }
}
